<template>
  <div class="containr">
    <div class="footer-background">
      <div class="company-image">
        <img style="width: 100%;height: 100%" src="http://imgcdn.scxdzc.com/scxdzhongchuang/LOGOA.png">
      </div>
      <div class="tags">
        <template>
          <el-tabs type="card" v-model="activeValue" @tab-click="handleClick">
            <el-tab-pane>
              <span slot="label" class="tag-title">首页</span>
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label" class="tag-title">关于我们</span>
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label" class="tag-title">产品品牌</span>
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label" class="tag-title">联系我们</span>
            </el-tab-pane>
          </el-tabs>
        </template>
      </div>
      <div class="contact">
        <div class="contact-body" style="">
        <div class="contact-phone">
          <div class="phone-top">联系电话</div>
          <div class="phone-bottom">0830-3192239</div>
        </div>
        <div class="contact-email">
          <div class="email-top">联系邮箱</div>
          <div class="email-bottom">3255206320@qq.com</div>
        </div>
        </div>
      </div>
      <div class="code">
        <div class="code-father">
          <div class="code-son-one">
            <div class="code-image">
              <img style="width: 100%;height: 100%" src="http://imgcdn.scxdzc.com/scxdzhongchuang/qq-image.png">
            </div>
            <div class="code-title">抖音账号</div>
          </div>
          <div class="code-son-two">
            <div class="code-image">
              <img style="width: 100%;height: 100%" src="http://imgcdn.scxdzc.com/scxdzhongchuang/wechat-image.png">
            </div>
            <div class="code-title">微信公众号</div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="footer-font-one">地址：四川省泸州市江阳区康城路一段7号1号楼14层1403号</div>
        <div class="footer-font-two">Copyright©2002-2022 四川信达中创科技发展有限公司,All Rights Reserved.</div>
<!--        <div class="footer-font-third" @click="jump">蜀ICP备2020029855号-1</div>-->
        <a class="footer-font-third" href="https://beian.miit.gov.cn/">蜀ICP备2020029855号-1</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FOOTER",
  data(){
    return{
      activeValue:null,
    }
  },
  mounted() {
       if(sessionStorage.getItem("tagIndex")!=null ||sessionStorage.getItem("tagIndex")!=undefined){
         this.activeValue = sessionStorage.getItem("tagIndex")
       }
    },
  computed:{
    tagIndex() {
      return this.$store.state.tagIndex;
    }
  },
  watch:{
    tagIndex:{
      immediate:true,
      handler(newValue){
        if(this.$store.state.tagIndex != this.activeValue){
           this.activeValue = newValue
        }
      }
    }
  },
  methods:{
    handleClick(tag){
      this.$store.dispatch('changeDispatch',tag.index)
      sessionStorage.setItem("tagIndex",tag.index)
      switch (tag.index){
        case "0":
          console.log("one")
          this.$router.push("/homeOne",()=>{})
          break;
        case "1":
          this.$router.push("/homeTwo",()=>{})
          break;
        case "2":
          this.$router.push("/homeThird",()=>{})
          break;
        case "3":
          this.$router.push("/homeFour",()=>{})
          break;
      }
    },
    // jump(){
    //   window.location.href = "https://beian.miit.gov.cn/"
    // }
  }
}
</script>

<style scoped lang="scss">
div {
  font-family: HarmonyOS_Sans_Black;
}
.containr{
  max-width: 100%;
  min-width: 1300px;
  height: 671px;
  margin-top: 100px;
}
.footer-background{
  width: 100%;
  height: 671px;
  background-image: url("http://imgcdn.scxdzc.com/scxdzhongchuang/back-bottom2.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.company-image{
  width: 189px;
  height: 52px;
  padding-top: 72px;
}
.tags{
  margin-top: 48px;
}
.tag-title{
  font-family: HarmonyOS_Sans_Black;
  font-size: 16px;
  color: aliceblue;
}
.contact{
  margin-top: 48px;
  width: 100%;
  height: 46px;
  display: flex;
  //margin-left:16px;
  justify-content: center;
  .contact-phone{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    //width: 97px;
    width: auto;
    height: 46px;
    margin-left: 22px;
    .phone-top{
      color: rgb(204, 204, 204);
      font-size: 14px;
      font-weight: 290;
      line-height: 19px;
      letter-spacing: 0px;
      text-align: left;
    }
    .phone-bottom{
      color: rgb(255, 255, 255);
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: 0px;
      text-align: left;
    }
  }
  .contact-email{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 147px;
    height: 46px;
    margin-left: 48px;
    .email-bottom{
      color: rgb(255, 255, 255);
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: 0px;
    }
    .email-top{
      color: rgb(204, 204, 204);
      font-size: 14px;
      font-weight: 290;
      line-height: 19px;
      letter-spacing: 0px;
      text-align: left;
    }
  }
}
.contact-body{
  //width: 292px;
  display: flex;
  justify-content: space-between;
}
.code{
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}
.code-father{
  display: flex;
  justify-content: space-between;
  width: 260px;
  height: 127px;
  margin-top: 48px;
  .code-son-one,.code-son-two{
    height: 100%;
    width: 90.13px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .code-image{
    width: 90.13px;
    height: 90px;
  }
  .code-title{
    height: 21px;
    margin-top: 16px;
    color: rgb(255, 255, 255);
    font-size: 16px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0px;
    text-align: center;
  }
}
.footer{
  margin-top: 48px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .footer-font-one,.footer-font-two,.footer-font-third{
    height: 19px;
    color: rgb(255, 255, 255);
    font-size: 14px;
    font-weight: 290;
    line-height: 19px;
    letter-spacing: 0px;
    text-align: left;
  }
  .footer-font-two,.footer-font-third{
    margin-top: 16px;
  }
}
@media screen and (min-width: 0px) and (max-width: 570px){
  .contact{
    margin-left: 0 !important;
  }
  .containr{
    min-width: 100px !important;
    height: auto !important;
  }
  .footer-background{
    height: auto !important;
  }
  .footer-font-one{
    font-size: 0.775rem !important;
  }
  .footer-font-two{
    height: auto !important;
    text-align: center !important;
    font-size: 0.775rem !important;
  }
  .footer-font-third{
    font-size: 0.775rem !important;
  }
  .footer-font-two,.footer-font-third{
    margin-top: 0px !important;
  }
  :deep(.el-tabs__item){
    padding: 0 13px !important;
  }
}
</style>
